export enum BillingMethod {
	Prepaid = "prepaid",
	UsageBased = "usage_based",
}
